/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantSiteViewModel } from '../../models/merchant-site-view-model';
import { PostMerchantSiteRequest } from '../../models/post-merchant-site-request';

export interface CreateMerchantSites$Params {
  merchantId: string;
      body: PostMerchantSiteRequest
}

export function createMerchantSites(http: HttpClient, rootUrl: string, params: CreateMerchantSites$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantSiteViewModel>> {
  const rb = new RequestBuilder(rootUrl, createMerchantSites.PATH, 'post');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantSiteViewModel>;
    })
  );
}

createMerchantSites.PATH = '/merchants/{merchantId}/sites';
